import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  socialNetwork: { id: 'Social Network', defaultMessage: 'Social Network' },
  socialNetworkUrl: {
    id: 'Social Network URL',
    defaultMessage: 'Social Network URL',
  },
  socialNetworkUrlHelp: {
    id: 'Social Network URL Help',
    defaultMessage:
      'Full site URL to destination. Eg.: https://www.nomedarede.com/governodobrasil',
  },
  WhatsAppChannel: {
    id: 'WhatsAppChannel',
    defaultMessage: 'WhatsApp Channel',
  },
  WhatsAppLink: {
    id: 'WhatsAppLink',
    defaultMessage: 'WhatsApp Link',
  },
  WhatsAppTelephone: {
    id: 'WhatsAppTelephone',
    defaultMessage: 'WhatsApp Telephone',
  },
});

const itemSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.socialNetwork),
    properties: {
      social_network: {
        title: intl.formatMessage(messages.socialNetwork),
        required: true,
        noValueOption: false,
        default: 'Facebook',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['Facebook', 'Facebook'],
          ['Flickr', 'Flickr'],
          ['Instagram', 'Instagram'],
          ['Kwai', 'Kwai'],
          ['Linkedin', 'Linkedin'],
          ['RSS', 'RSS'],
          ['Slideshare', 'Slideshare'],
          ['Soundcloud', 'Soundcloud'],
          ['Thumblr', 'Thumblr'],
          ['TikTok', 'TikTok'],
          ['WhatsAppChannel', intl.formatMessage(messages.WhatsAppChannel)],
          ['WhatsAppLink', intl.formatMessage(messages.WhatsAppLink)],
          ['WhatsAppTelephone', intl.formatMessage(messages.WhatsAppTelephone)],
          ['Twitter', 'X'],
          ['Youtube', 'Youtube'],
        ],
      },
      social_network_url: {
        title: intl.formatMessage(messages.socialNetworkUrl),
        description: intl.formatMessage(messages.socialNetworkUrlHelp),
        required: true,
      },
    },
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.socialNetwork),
        fields: ['social_network', 'social_network_url'],
      },
    ],
    required: ['social_network', 'social_network_url'],
  };
};

const SocialNetworksWidget = (props) => {
  return (
    <ObjectListWidget
      schema={itemSchema}
      {...props}
      value={props.value?.items || props.default?.items || []}
      onChange={(id, value) => props.onChange(id, { items: value })}
    />
  );
};

export default SocialNetworksWidget;
